import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ModalLoginComponent } from './modal-login/modal-login.component';
import { SignupComponent } from '../shared/signup/signup.component';
import { SigninComponent } from '../shared/signin/signin.component';
import { ForgotPasswordComponent } from '../shared/forgot-password/forgot-password.component';
import { PipesModule } from 'app/pipes/pipes.module';
import { SharedModule } from 'app/shared.module';



@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        SharedModule,
        PipesModule,
        ReactiveFormsModule
    ],
    declarations: [
        ModalLoginComponent,  SigninComponent, SignupComponent, ForgotPasswordComponent
    ],
    exports: [ SigninComponent, SignupComponent, ForgotPasswordComponent ],
})
export class ModalsModule { }
